export const Races = Object.freeze({
    white: { value: "white", label: "White / Caucasian" },
    black: { value: "black", label: "Black / African / African American" },
    latino: { value: "latino", label: "Latino / Hispanic / Latin American" },
    asian: { value: "asian", label: "Asian" },
    mena: { value: "mena", label: "Middle Eastern / North African (MENA)" },
    indigenous: { value: "indigenous", label: "Native American / Indigenous" },
    pacific: { value: "pacific", label: "Pacific Islander / Native Hawaiian" },
    mixed: { value: "mixed", label: "Mixed / Multiracial" },
    other: { value: "other", label: "Other" },

    getAllOptions() {
        return Object.keys(this)
            .filter((key) => typeof this[key] === "object")
            .map((key) => this[key]);
    },
});
